import React  from "react";
import TrainingClassTable from "./components/TrainingClassTable";
import { connect } from "react-redux";


const TrainingClasses = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<TrainingClassTable/>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClasses);